import type { ArticleSummary, NewsBlock } from '@publiqa/shared'
import { useFetch } from '../../lib/useFetch'
import { SmartLink, usePubliqApi } from '../context'
import { ArticleCard } from '../ui'
import { SectionHead } from './Blocks'

/**
 * Dernières actualités. Présentations :
 *   grid      cartes en grille
 *   list      liste (image à gauche)
 *   featured  l'article « à la une » en grand, puis les suivants
 * Chaque carte ouvre la page complète de l'article.
 */
export function NewsView({ b }: { b: NewsBlock }) {
  const path = usePubliqApi()
  const { data, loading } = useFetch<{ articles: ArticleSummary[] }>(
    path('/articles', {
      limit: b.count,
      category: b.category || undefined,
      featuredFirst: b.layout === 'featured' ? 1 : undefined,
    }),
  )
  const articles = data?.articles ?? []
  if (!loading && !articles.length) return null
  const [lead, ...rest] = articles
  return (
    <section className="b-section b-news">
      <div className="container">
        <div className="news-head">
          <SectionHead title={b.title} />
          {(b.moreLabel ?? 'Toutes les actualités →') && (
            <SmartLink
              href={b.category ? `/rubrique/${b.category}` : '/actualites'}
              className="more"
            >
              {b.moreLabel ?? 'Toutes les actualités →'}
            </SmartLink>
          )}
        </div>
        {b.layout === 'featured' && lead ? (
          <div className={`news-featured${rest.length ? '' : ' single'}`}>
            <ArticleCard article={lead} variant="overlay" badge />
            {rest.length > 0 && (
              <div className="news-featured-side">
                {rest.map((a) => (
                  <ArticleCard key={a.id} article={a} variant="side" badge />
                ))}
              </div>
            )}
          </div>
        ) : (
          <div className={b.layout === 'grid' ? 'grid cols-3' : 'news-list'}>
            {articles.map((a) => (
              <ArticleCard
                key={a.id}
                article={a}
                variant={b.layout === 'grid' ? 'card' : 'row'}
                badge
              />
            ))}
          </div>
        )}
      </div>
    </section>
  )
}
